export default "/images/d6ae53df38ede6e8d4f473c392f0e984.png";